import React from "react";
import CmsBlock from "@/bit/components/components.cms/cms-block";
import CmsForm from "@/bit/components/components.cms-block.cms-form.cms-form";
import CmsPageProps from "@/bit/components/components.cms-block.cms-page-props";
// import CmsForm from "@/component/cms-form/cms-form";

const COMPONENTS_KEYS = {
  "cms-component-form": CmsForm,
};

const LayoutCMS = ({
  breadcrumbsProps,
  headerProps,
  seoInfo,
  footerProps,
  orionInfo,
  orionAlias,
}) => {
  const {
    "components-order": componentsOrder,
    "hidden-components": hiddenComponents,
  } = orionInfo;
console.log(orionInfo)
  return (
    <>
      <main>
        {orionInfo && orionInfo["cms-page-props"] && <CmsBlock
          alias={orionAlias}
          orionInfo={orionInfo}
          blockName="cms-page-props"
          Component={CmsPageProps}
          kind="page-props"
          externalProps={{headerProps, seoInfo}}
        />}
        {componentsOrder &&
          Array.isArray(componentsOrder) &&
          componentsOrder.length > 0 &&
          componentsOrder.map((key) => {
            const baseKey = key.replace(/-\d+$/, ""); // Eliminar el sufijo numérico
            const Component = COMPONENTS_KEYS[baseKey];
            return (
              Component && orionInfo && orionInfo[key] && (
                <CmsBlock
                  key={`cms-component--${key}`}
                  alias={orionAlias}
                  orionInfo={orionInfo}
                  blockName={key}
                  Component={Component}
                  blurComponent={
                    hiddenComponents && hiddenComponents.includes(key)
                  }
                />
              )
            );
          })}
      </main>
    </>
  );
};

export default LayoutCMS;
